import { cx } from '@linaria/core';
import { useRef, useId } from 'react';
import { ElementToolbar } from '@pm2/element-toolbar';
import { textColumnCls } from '@pm2/react-utils';
import { useSpeechSynthesisConfig } from '@provider/speech-synthesis';
import { Tooltip, SpeechButton } from '@ui/kit';
import { printHtmlNodesToJsx } from '@utils/ast';
import { RetryButton } from '@utils/component-framework';
import { useKatex, Chevron } from '@utils/react';
import { wrapper, heading, collapseChevron, headingDescription, title, header, resetButton } from './component.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { CardSlider } from './organism.card-slider/card-slider.js';

function Component(props) {
  const internalRef = useRef(null);
  const ref = props.ref ?? internalRef;
  const id = `flashcard-${useId()}`;
  const speechConfig = useSpeechSynthesisConfig();
  useKatex(ref);
  const withSpeechButton = speechConfig.enabled && props.context !== "embedded";
  return /*#__PURE__*/jsxs("section", {
    id: id,
    className: wrapper,
    "data-context": props.context,
    children: [props.title && /*#__PURE__*/jsxs("header", {
      className: cx(textColumnCls, header, props.enableElementToolbar && props.node && "hasContextMenu"),
      children: [/*#__PURE__*/jsxs("span", {
        className: cx(title, !!props.onCollapse && "collapsible"),
        onClick: props.onCollapse,
        children: [/*#__PURE__*/jsx("h3", {
          className: heading,
          children: props.title
        }), props.onCollapse && /*#__PURE__*/jsx(Tooltip, {
          body: "Luk opgaven",
          placement: "right",
          ariaType: "label",
          children: ref => /*#__PURE__*/jsx("button", {
            ref: ref,
            className: collapseChevron,
            onClick: props.onCollapse,
            children: /*#__PURE__*/jsx(Chevron, {
              vertical: true,
              size: 10,
              inversed: true,
              lineWidth: 2
            })
          })
        }), props.context === "embedded" && props.node?.meta.richTextDescription && /*#__PURE__*/jsx("div", {
          className: headingDescription,
          children: printHtmlNodesToJsx(props.node.meta.richTextDescription)
        })]
      }), props.enableElementToolbar && props.node && /*#__PURE__*/jsx(ElementToolbar, {
        node: props.node
      })]
    }), /*#__PURE__*/jsx(CardSlider, {
      ...props,
      ref: ref
    }), /*#__PURE__*/jsx(RetryButton, {
      className: resetButton,
      context: "button",
      onReset: props.onResetEntry
    }), withSpeechButton && /*#__PURE__*/jsx("div", {
      style: {
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: "2000"
      },
      children: /*#__PURE__*/jsx(SpeechButton, {
        flagPlacement: "top",
        tooltipPlacement: "left",
        rootSelector: `section.${wrapper}[id="${id}"]`
      })
    })]
  });
}

export { Component };
//# sourceMappingURL=component.js.map
